(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["edzb-pressefotos"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const link = event.target.closest('a[data-edzb-download]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(link.href, { headers: { Accept: 'image/jpeg,image/png,application/pdf,*/*;q=0.5' } });
      if (!response.ok) throw new Error(String(response.status));
      const url = URL.createObjectURL(await response.blob());
      const temp = document.createElement('a');
      temp.href = url;
      temp.download = link.dataset.edzbDownload;
      document.body.append(temp);
      temp.click();
      temp.remove();
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch (error) {
      window.location.href = link.href;
    } finally {
      link.removeAttribute('aria-busy');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
